import React,{useState} from 'react';
import '../styles/Cards.css';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import placeholder from '../img/placeholder.jpeg'
import projectplaceholder from '../img/projectplaceholder.jpg'
import studlydozen from '../img/studlydozen.jpg'
import studlabscreationprocess from '../img/stud-labs-creative-process.jpg'
import studlabsgenesiscollection from '../img/stud-labs-collection-genesis.jpg'
import logo from '../img/placeholder.com-logo1_637146769278368505.jpg'
import logo2 from '../img/placeholder.png'
import logo3 from '../img/apesman.png'


function Cards() {
  return (
    <>
    <div className="wrapper">
      <div className='about-content section' id='about'>
        <div className="inner">
        <Fade top>
        <h2>Stud Labs was inspired by Studs. <br/><p>Created by Studs. For Studs.</p></h2>

        <p>The founders of Stud Labs, Neo and Kei (pronounced as K), are 2 studly friends who have known each other since the beginning of time and shared a common passion for all things studly/bricks. Neo is a web developer and Kei is a design consultant. They each have more than 15 years of experience in their respective fields of expertise. Combining their studliness, Stud Labs was formed to create and launch a series of NFTs inspired by iconic personalities and characters from our generation.</p>
        <p>GENESIS is the first of a series of inspired NFTs by the studly duo.</p>
        </Fade>
        </div>
      </div>
      <div className='section zero' id='collections'>
        <Fade top>
          <div className="inner">
            <h2>STUD COLLECTIONS</h2>
            <p>NFTs inspired by iconic personalities and characters from a generation of studliness.</p>
          </div>
          </Fade>  
          <br/>
          <Fade>
            <div className="aboutContents">
              <div className="card-wrapper">
                <div className="left">
                  <div className="card-image">
                    <img src={studlabsgenesiscollection}/>
                  </div>
                </div>
                <div className="right">
                  <h3>GENESIS</h3>
                  <p>The first collection. The first 10,000. How it all begins.</p>
                  <div id='mintBtn'>JUNE 2022</div>
                </div>
              </div>
              <div className="card-wrapper">
                <div className="left">
                  <div className="card-image">
                    <img src={studlydozen}/>
                  </div>
                </div>
                <div className="right">
                  <h3>The Studly Dozen</h3>
                  <p>12 high quality custom-crafted NFTs for your PFP. Just 10 pieces each.</p>
                  <div id='mintBtn'>JUNE 2022</div>
                </div>
              </div>
              <div className="card-wrapper">
                <div className="left">
                  <div className="card-image">
                    <img src={projectplaceholder}/>
                  </div>
                </div>
                <div className="right">
                  <h3>What's Next?</h3>
                  <p>Where will our partnerships and collaborations bring us?</p>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      <div className='section' id='creation'>
        <div className="creationContents">
          <Fade left>
            <div className="left">
                <h2>The Creation Process</h2>
                <p>In order to maintain the uniqueness and integrity of each layered asset/trait. The artwork for each asset/trait boasts unique colours, textures or details. Every asset is painstakingly created from vectors requiring hours upon hours of refinement ensuring your NFT is of the best possible resolution/quality when generated in a 1080 x 1080 format.</p>
                <p>We also had to reign in the studliness in the creation process to prevent a studlines overload.</p>
            </div>
          </Fade>
          <Fade right>
            <div className="right">
              <div className="glow"></div>
              <img src={studlabscreationprocess}/>
            </div>
          </Fade>
        </div>
      </div>
      <div className='section zero' id='sponsors'>
        <Fade top><h2>Sponsors</h2></Fade>
        <br/>
        <Fade>
          <div className='sponsors__wrapper'>
              <a href="https://google.com"><img src={logo2}/></a>
              <a href="#"><img src={logo2}/></a>
              <a href="https://apesman.com/" target="_blank"><img src={logo3}/></a>
              <a href="#"><img src={logo2}/></a>
              <a href="#"><img src={logo2}/></a>
          </div>
        </Fade>
      </div>
    </>
  );
}

export default Cards;
